<template>
  <div class="main">
    <div class="body">
      <van-swipe class="swiper" @change="swiperChange" :loop="false">
        <van-swipe-item v-for="(item, i) of D._swiper" :key="i">
          <div v-if="item.type == 'video'" class="video">
            <video ref="video" class="item" :src="item.url" />
            <img
              v-if="!play"
              src="@/assets/groupRob/play.png"
              class="play"
              alt=""
              @click="playVideo"
            />
          </div>
          <img v-else class="img" :src="item.url" alt="" />
        </van-swipe-item>
        <template #indicator>
          <div class="swiper-indicator">{{ current + 1 }}/4</div>
        </template>
      </van-swipe>
      <div class="info">
        <div class="price">
          <div>
            <span class="rmb">¥</span>
            <span class="large">{{ D._price_l }}</span>
            <span>.{{ D._price_s }}</span>
            <span class="old">原价 ¥</span>
            <span class="old del">{{ D._price_o }}</span>
          </div>
        </div>
        <div class="join">
          <span>已参与</span>
          <div class="num">{{ D._join_num }}人</div>
        </div>
      </div>
      <div class="title">
        <div class="name">{{ D._name }}</div>
      </div>
      <div class="detail-title">- 商品详情 -</div>
      <div class="detail" v-html="D._content"></div>
    </div>
    <div class="footer" safe-area-inset-bottom>
      <template v-if="D._status == 1">
        <div v-if="isWeixin" class="btn" v-html="renderDom()"></div>
        <div v-else class="btn" @click="toJoin">立即报名</div>
      </template>
      <div v-else class="btn disabled">报名已结束</div>
    </div>
  </div>
</template>

<script>
import mixin from "./mixin";

export default {
  mixins: [mixin],
  data() {
    return {
      current: 0,
      play: false,
      D: {},
      id: null,
      isWeixin: false,
      isBan: false,
    };
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getDetail();
    }
    var u = navigator.userAgent;
    this.isWeixin = u.toLowerCase().indexOf("micromessenger") !== -1; // 微信内
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (
      u.toLowerCase().indexOf("qq") > -1 &&
      u.toLowerCase().indexOf("mqqbrowser") < 0 &&
      isIOS
    ) {
      this.isBan = true;
    }
  },
  mounted() {
    this.$api
      .post("member/index/wechat/get/sign/package", {
        type: 2,
        url: location.href,
      })
      .then((res) => {
        wx.config({
          debug: false,
          appId: res.appId,
          nonceStr: res.nonceStr,
          signature: res.signature,
          timestamp: res.timestamp,
          jsApiList: ["checkJsApi"],
          openTagList: ["wx-open-launch-app"],
        });
      });
  },
  methods: {
    swiperChange(e) {
      this.current = e;
      this.play = false;
      if (this.$refs.video) {
        this.$refs.video[0].pause();
      }
    },
    playVideo() {
      this.play = true;
      if (this.$refs.video) {
        this.$refs.video[0].play();
      }
    },
    renderDom() {
      let _script = document.createElement("script");
      _script.type = "text/wxtag-template";
      _script.text =
        "<style> .btn { height: 42px; display: flex; justify-content: center; align-items: center; font-size: 15px; color: #fff; font-weight: 700; border-radius: 21px; } </style>";
      _script.text += `<div class="btn">立即报名</div>`;
      const extinfo = encodeURIComponent(
        JSON.stringify({ type: "grouprob", id: this.id })
      );
      let html = `<wx-open-launch-app id="launch-btn" class="btn" appid="wxc1265f98df56cd07" extinfo="${extinfo}" > ${_script.outerHTML} </wx-open-launch-app> `;
      return html;
    },
    getDetail() {
      this.$api
        .get("ongoods/index/goods/detail", { id: this.id })
        .then((res) => {
          const _goods = res.goods;
          const _activity = res.platform_activity;
          res._id = _goods.id;
          res._name = _goods.name;
          res._content = _goods.info && _goods.info.content;
          res._swiper = [];
          if (_goods.video) {
            res._swiper = res._swiper.concat(
              _goods.video.map((_) => ({
                type: "video",
                url: _,
              }))
            );
          }
          if (_goods.carousel) {
            res._swiper = res._swiper.concat(
              _goods.carousel.map((_) => ({
                type: "img",
                url: _,
              }))
            );
          }
          if (_activity) {
            res._join_num = _activity.order_num;
            res._price_o = _activity.data && _activity.data.strikeout_price;
            const _price =
              _activity.data &&
              _activity.data.activity_min_price &&
              _activity.data.activity_min_price.split(".");
            res._price_l = _price && _price[0];
            res._price_s = (_price && _price[1]) || "00";
            res._status = _activity.status;
          }
          this.D = res;
          console.log(this.D);
        });
    },
    toJoin() {
      if (this.isBan) {
        return this.$toast("请在浏览器中打开");
      }
      this.openApp(null, null, `?type=grouprob&id=${this.id}`);
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  font-size: 1.4rem;
  color: #333;
  background: #f5f6f7;
  height: 100vh;
  overflow: hidden;

  .body {
    flex: 1;
    overflow: auto;
  }

  .swiper {
    flex: 0 0 38rem;
    position: relative;
    background: #fff;
    font-size: 0;

    .img,
    .video {
      width: 37.5rem;
      height: 38rem;
      position: relative;

      .item {
        width: 100%;
        height: 100%;
      }

      .play {
        width: 5.8rem;
        height: 5.8rem;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    &-indicator {
      box-sizing: border-box;
      position: absolute;
      right: 1.2rem;
      bottom: 1.2rem;
      width: 4rem;
      height: 2.7rem;
      background: rgba(0, 0, 0, 0.6);
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 1.4rem;
      color: #fff;
      font-weight: 700;
      font-size: 1.4rem;
    }
  }

  .info {
    height: 4.5rem;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    background: linear-gradient(270deg, #ffeae9 0%, #ffeae9 100%);
    color: #fff;

    .price {
      flex: 0 0 28.2rem;
      box-sizing: border-box;
      font-size: 1.3rem;
      font-weight: 700;
      padding-left: 4.8rem;
      background: url(~@/assets/groupRob/price-bg.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      align-items: center;

      .rmb {
        font-size: 1.4rem;
      }

      .large {
        font-size: 2.2rem;
      }

      .old {
        margin-left: 0.6rem;
        font-weight: 400;
      }

      .del {
        margin-left: 0;
        text-decoration: line-through;
      }
    }

    .join {
      flex: 0 0 9.3rem;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      align-items: center;
      color: #f71471;
      font-size: 1rem;
      font-weight: 700;

      .num {
        padding: 0 0.7rem;
        background: #f71471;
        height: 1.9rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 1.1rem;
        color: #fff;
        font-size: 1.2rem;
      }
    }
  }

  .title {
    padding: 1rem 1.2rem;
    background: #fff;

    .name {
      font-size: 1.6rem;
      font-weight: 700;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .detail-title {
    padding: 0.6rem 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #999999;
    font-size: 1.3rem;
    background: #fff;
    margin-top: 1.2rem;
  }

  .detail {
    /deep/ img {
      max-width: 100%;
      margin-bottom: -3px;
    }
  }

  .footer {
    box-sizing: border-box;
    padding: 0.6rem 1.2rem;
    width: 37.5rem;
    background: #fff;

    .btn {
      width: 100%;
      height: 4.2rem;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 1.5rem;
      color: #fff;
      font-weight: 700;
      border-radius: 2.1rem;
      background: linear-gradient(270deg, #ff003f 0%, #ff6900 100%);

      &.disabled {
        background: #d9d7dc;
        pointer-events: none;
      }
    }
  }
}
</style>
